import { render, staticRenderFns } from "./cmp.vue?vue&type=template&id=54b51a4d&scoped=true&lang=pug&"
import script from "./cmp.js?vue&type=script&lang=js&"
export * from "./cmp.js?vue&type=script&lang=js&"
import style0 from "./cmp.vue?vue&type=style&index=0&id=54b51a4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b51a4d",
  null
  
)

export default component.exports